export default __webpack_public_path__ + "static/pixea-example3-4549adba0086663396150e4f15ecabaf.png";